import { FileText } from 'lucide-react';
import { PostCard } from './PostCard';
import type { ChPost } from '../types';

interface Props {
  posts: ChPost[];
  onPostClick: (post: ChPost) => void;
  names?: Map<string, string>;
}

export function PostGrid({ posts, onPostClick, names }: Props) {
  if (posts.length === 0) {
    return (
      <div className="ch-card">
        <div className="ch-empty">
          <FileText className="ch-empty-icon" />
          <p className="text-gray-500 font-medium">Sem posts</p>
          <p className="text-sm text-gray-400 mt-1">Cria o primeiro post deste projeto.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {posts.map(post => (
        <PostCard key={post.id} post={post} onClick={onPostClick} names={names} />
      ))}
    </div>
  );
}
